module.exports = __webpack_public_path__ + "img/stop-13.b9361208.jpg";